import i18n from "@/plugins/i18n";
import utils from "@/utils";

export default {
  company: {
    url: "/v1/all/company",
    routeTable: "data/companies",
    editable: true,
    pageable: true,
    showCompany: false,
    role: {
      read: "admin",
      write: "superuser"
    },
    getTableName() {
      return i18n.t("data.item.companies");
    },
    getItemName(obj, withPrefix = false) {
      if (withPrefix)
        return i18n.t("data.item.company") + " - " + (obj.name || i18n.t("data.item.new_item"));
      else
        return (obj.name || i18n.t("data.item.new_item"));
    },
    listParams: function(params) {
      return `?size=${params.size}`;
    }
  },

  "special-access": {
    url: "/v1/all/special-access",
    routeTable: "data/special-accesses",
    editable: true,
    pageable: true,
    showCompany: false,
    role: {
      read: "superuser",
      write: "superuser"
    },
    getTableName() {
      return i18n.t("data.item.special-accesses");
    },
    getItemName(obj, withPrefix = false) {
      if (withPrefix)
        return i18n.t("data.item.special-access") + " - " + (utils.formatName(obj.firstName, obj.lastName) || i18n.t("data.item.new_item"));
      else
        return (utils.formatName(obj.firstName, obj.lastName) || i18n.t("data.item.new_item"));
    },
    listParams: function(params) {
      return `?size=${params.size}`;
    }
  },

  person: {
    url: "/v1/{#company#}/person",
    routeTable: "data/persons",
    editable: true,
    pageable: true,
    showCompany: true,
    role: {
      read: "admin",
      write: "admin",
      delete: "superuser"
    },
    getTableName() {
      return i18n.t("data.item.persons");
    },
    getItemName(obj, withPrefix = false) {
      if (withPrefix)
        return i18n.t("data.item.person") + " - " + (utils.formatName(obj.firstName, obj.lastName) || i18n.t("data.item.new_item"));
      else
        return (utils.formatName(obj.firstName, obj.lastName) || i18n.t("data.item.new_item"));
    },
    listParams: function(params) {
      return `?size=${params.size}`;
    }
  },

  groupset: {
    url: "/v1/{#company#}/groupset",
    routeTable: "data/groupsets",
    editable: true,
    pageable: false,
    showCompany: true,
    role: {
      read: "admin",
      write: "admin"
    },
    getTableName() {
      return i18n.t("data.item.groupsets");
    },
    getItemName(obj, withPrefix = false) {
      if (withPrefix)
        return i18n.t("data.item.groupset") + " - " + (obj.name || i18n.t("data.item.new_item"));
      else
        return (obj.name || i18n.t("data.item.new_item"));
    },
    getParams: function() {
      return `?all=true`;
    }
  },

  sharing: {
    url: "/v1/{#company#}/sharing",
    routeTable: "data/sharings",
    editable: true,
    pageable: true,
    showCompany: true,
    role: {
      read: "dispatcher",
      write: "dispatcher"
    },
    getTableName() {
      return i18n.t("data.item.sharings");
    },
    getItemName(obj, withPrefix = false) {
      if (withPrefix)
        return i18n.t("data.item.sharing") + " - " + (obj.hashCode || i18n.t("data.item.new_item"));
      else
        return (obj.name || i18n.t("data.item.new_item"));
    },
    getParams: function() {
      return `?all=true`;
    }
  },

  contract: {
    url: "/v1/{#company#}/contract",
    routeTable: "data/contracts",
    editable: true,
    pageable: true,
    showCompany: true,
    periodView: true,
    role: {
      read: "driver",
      write: "dispatcher",
      authority: "contract"
    },
    getTableName() {
      return i18n.t("data.item.contracts");
    },
    getItemName(obj, withPrefix = false) {
      if (withPrefix)
        return i18n.t("data.item.contract") + " - " + (obj.name || i18n.t("data.item.new_item"));
      else
        return (obj.name || i18n.t("data.item.new_item"));
    },
    listParams: function(params) {
      return `?from=${encodeURIComponent(params.periodFrom)}&to=${encodeURIComponent(params.periodTo)}&size=${params.size}`;
    }
  },

  subject: {
    url: "/v1/{#company#}/subject",
    routeTable: "data/subjects",
    editable: true,
    pageable: true,
    showCompany: true,
    periodView: false,
    role: {
      read: "driver",
      write: "dispatcher",
      authority: "contract"
    },
    getTableName() {
      return i18n.t("data.item.subjects");
    },
    getItemName(obj, withPrefix = false) {
      if (withPrefix)
        return i18n.t("data.item.subject") + " - " + (obj.name || i18n.t("data.item.new_item"));
      else
        return (obj.name || i18n.t("data.item.new_item"));
    },
    listParams: function(params) {
      return `?size=${params.size}`;
    }
  },

  service: {
    url: "/v1/{#company#}/service",
    routeTable: "data/services",
    editable: true,
    pageable: true,
    showCompany: true,
    periodView: true,
    role: {
      read: "driver",
      write: "dispatcher"
    }
  },

  vehicle: {
    url: "/v1/{#company#}/vehicle",
    listUrl: "/v1/{#company#}/vehicle-map",
    routeTable: "data/vehicles",
    editable: true,
    pageable: true,
    showCompany: true,
    role: {
      read: "admin",
      write: "superuser"
    },
    getTableName() {
      return i18n.t("data.item.vehicles");
    },
    getItemName(obj, withPrefix = false) {
      if (withPrefix)
        return i18n.t("data.item.vehicle") + " - " + (obj.numericPlate || i18n.t("data.item.new_item"));
      else
        return (obj.name || i18n.t("data.item.new_item"));
    },
    listParams: function(params) {
      return `?all=true&size=${params.size}`;
    }
  },

  "device-connection": {
    url: "/v1/admin/device-connections",
    routeTable: "data/device-connections",
    editable: false,
    pageable: false,
    showCompany: false,
    role: {
      read: "superuser",
      write: "superuser"
    },
    getTableName() {
      return i18n.t("data.item.deviceConnections");
    }
  },

  "api-connection": {
    url: "/v1/admin/api-connections",
    routeTable: "data/api-connections",
    editable: false,
    pageable: false,
    showCompany: false,
    role: {
      read: "superuser",
      write: "superuser"
    },
    getTableName() {
      return i18n.t("data.item.apiConnections");
    }
  }
};
